import { callProxy } from "./api";

const BASE = "/api/holiday-packages"; // ✅ backend route base

export async function fetchPackages(token) {
  const res = await callProxy(BASE, token);
  return Array.isArray(res.data) ? res.data : [];
}

export async function fetchPackageBySlug(slug, token) {
  const res = await callProxy(`${BASE}/${slug}`, token);
  return res.data;
}

export function likePackage(slug) {
  return callProxy(`${BASE}/${slug}/like`, null, {
    method: "POST",
    body: {
      visitorId: localStorage.getItem("visitorId"),
    },
  });
}
